export default __webpack_public_path__ + "static/media/CHAdeMO.e61535aa.png";